import React, { useState } from 'react';

const Hero = () => {
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const [tooltipPos, setTooltipPos] = useState({ x: 0, y: 0 });

  const handleWaveEnter = (e) => {
    const rect = e.target.getBoundingClientRect();
    setTooltipPos({ x: rect.left, y: rect.top - 40 });
    setTooltipVisible(true);
  };

  const handleWaveLeave = () => {
    setTooltipVisible(false);
  };

  return (
    <section className="hero" id="home">
      <div className="container">
        <p className="hero-intro">
          Cześć{' '}
          <span 
            className="secret-wave" 
            style={{ cursor: 'pointer' }}
            onMouseEnter={handleWaveEnter}
            onMouseLeave={handleWaveLeave}
          >
            👋
          </span>
        </p>
        {tooltipVisible && (
          <div 
            className="secret-tooltip show" 
            style={{ 
              position: 'fixed', 
              left: `${tooltipPos.x}px`, 
              top: `${tooltipPos.y}px` 
            }}
          >
            🎉 Znalazłeś mnie! Spróbuj wpisać: SECRET
          </div>
        )}
        <h1 className="hero-title">
          Tworzymy <span className="highlight">nowoczesne</span> i{' '}
          <span className="highlight">skalowalne</span> rozwiązania webowe dla firm,
          które chcą wyróżnić się w cyfrowym świecie.
        </h1>
        <p className="hero-description">
          Specjalizujemy się w tworzeniu aplikacji webowych, platform e-commerce i
          systemów zarządzania, które napędzają rozwój biznesu.
        </p>
        <div className="cta-buttons">
          <a href="#projects" className="cta-button">
            Zobacz nasze projekty
          </a>
          <a href="#contact" className="cta-button primary">
            Skontaktuj się
          </a>
        </div>
      </div>
    </section>
  );
};

export default Hero;
